import { OurValue } from "@/types/about-us-page";
import React from "react";
import { useTranslation } from "react-i18next";

interface IconProps {
  className?: string; // Add className as an optional prop
}

const TransparencyIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} width="26" height="26" viewBox="0 0 26 26" fill="none">
    <g id="ic/transparency">
      <circle
        id="Ellipse 9"
        cx="10"
        cy="10"
        r="9"
        stroke="#232329"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        id="Ellipse 10"
        cx="16"
        cy="16"
        r="9"
        stroke="#232329"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const CollaborationIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} width="26" height="21" viewBox="0 0 26 21" fill="none">
    <g id="28-collaborative">
      <g id="Flat">
        <path
          id="Vector"
          d="M14 4.66628H8.73025C8.9341 4.31608 9.02604 3.91194 8.99375 3.50803C8.95293 2.99287 8.71429 2.51352 8.32785 2.17042C7.94142 1.82733 7.43718 1.64712 6.92081 1.66759C6.40445 1.68805 5.91605 1.90758 5.55797 2.28018C5.19989 2.65277 4.99993 3.14951 5 3.66628C5 4.01759 5.09307 4.36263 5.26975 4.66628H4.2C3.07989 4.66628 2.51984 4.66628 2.09202 4.88426C1.71569 5.07601 1.40973 5.38197 1.21799 5.7583C1 6.18612 1 6.74617 1 7.86628V13.4663C1 14.5864 1 15.1464 1.21799 15.5743C1.40973 15.9506 1.71569 16.2565 2.09202 16.4483C2.51984 16.6663 3.07989 16.6663 4.2 16.6663H5.26975C5.0659 17.0165 4.97396 17.4206 5.00625 17.8245C5.04707 18.3397 5.28571 18.819 5.67215 19.1621C6.05858 19.5052 6.56282 19.6854 7.07919 19.665C7.59555 19.6445 8.08395 19.425 8.44203 19.0524C8.80011 18.6798 9.00007 18.183 9 17.6663C9 17.315 8.90693 16.9699 8.73025 16.6663H14"
          stroke="#232329"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M20.7299 4.66602C20.9338 5.01621 21.0257 5.42035 20.9934 5.82427C20.9526 6.33942 20.7139 6.81878 20.3275 7.16187C19.9411 7.50497 19.4368 7.68517 18.9205 7.66471C18.4041 7.64425 17.9157 7.42471 17.5576 7.05212C17.1995 6.67952 16.9996 6.18278 16.9997 5.66602C16.9996 5.31471 17.0927 4.96967 17.2694 4.66602H13.9997C13.7344 4.66602 13.4801 4.77137 13.2925 4.95891C13.105 5.14645 12.9997 5.4008 12.9997 5.66602V8.93577C12.6495 8.732 12.2455 8.64003 11.8417 8.67214C11.3262 8.71257 10.8465 8.95104 10.503 9.33752C10.1596 9.724 9.97917 10.2285 9.99961 10.7451C10.02 11.2617 10.2398 11.7503 10.6126 12.1085C10.9855 12.4666 11.4826 12.6664 11.9997 12.666C12.351 12.666 12.696 12.5729 12.9997 12.3963V15.666C12.9997 15.9312 13.105 16.1856 13.2925 16.3731C13.4801 16.5607 13.7344 16.666 13.9997 16.666H17.2694C17.0656 16.3158 16.9736 15.9117 17.0059 15.5078C17.0467 14.9926 17.2854 14.5133 17.6718 14.1702C18.0582 13.8271 18.5625 13.6469 19.0788 13.6673C19.5952 13.6878 20.0836 13.9073 20.4417 14.2799C20.7998 14.6525 20.9997 15.1492 20.9997 15.666C20.9997 16.0173 20.9066 16.3624 20.7299 16.666H21.7997C22.9198 16.666 23.4798 16.666 23.9076 16.448C24.284 16.2563 24.5899 15.9503 24.7817 15.574C24.9997 15.1462 24.9997 14.5861 24.9997 13.466V7.86602C24.9997 6.74591 24.9997 6.18586 24.7817 5.75803C24.5899 5.38171 24.284 5.07575 23.9076 4.884C23.4798 4.66602 22.9198 4.66602 21.7997 4.66602H20.7299Z"
          stroke="#232329"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

const SustainabilityIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} width="26" height="25" viewBox="0 0 26 25" fill="none">
    <g id="Group 36">
      <path
        id="Ellipse 11"
        d="M2.87491 17.1238C4.57907 21.0209 8.46852 23.744 12.994 23.744C18.6526 23.744 23.3168 19.4865 23.9579 14M23.1131 8.28628C21.4089 4.38919 17.5195 1.66602 12.994 1.66602C7.13415 1.66602 2.3407 6.23184 1.97714 12"
        stroke="#232329"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 4"
        d="M19.9402 8.48691L23.4945 9.43928L24.4469 5.88499"
        stroke="#232329"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 5"
        d="M6.15293 17.1243L2.69517 15.8657L1.43665 19.3235"
        stroke="#232329"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const IntegrityIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} width="24" height="27" viewBox="0 0 24 27" fill="none">
    <g id="surface1">
      <path
        id="Vector"
        d="M21.1864 17.6931C20.5413 19.4413 19.5657 20.9615 18.2864 22.2108C16.8301 23.6328 14.9233 24.7628 12.6187 25.5688C12.5431 25.5952 12.4642 25.6168 12.3849 25.6327C12.2802 25.6534 12.1736 25.6646 12.0679 25.666H12.0472C11.9346 25.666 11.8215 25.6547 11.7092 25.6327C11.6299 25.6168 11.5521 25.5952 11.4769 25.5693C9.16956 24.7646 7.26031 23.6352 5.80261 22.2132C4.5227 20.9639 3.5473 19.4446 2.90313 17.6964C1.7318 14.5176 1.79846 11.0159 1.85211 8.20196L1.85302 8.15875C1.86382 7.92638 1.87078 7.6823 1.87463 7.41277C1.89422 6.08947 2.94634 4.99468 4.26983 4.92089C7.02923 4.7669 9.16388 3.86693 10.9878 2.08916L11.0037 2.07451C11.3066 1.79674 11.6882 1.66051 12.0679 1.66619C12.4341 1.67095 12.7989 1.80699 13.0909 2.07451L13.1065 2.08916C14.9308 3.86693 17.0654 4.7669 19.8248 4.92089C21.1483 4.99468 22.2005 6.08947 22.22 7.41277C22.2239 7.68414 22.2308 7.92785 22.2416 8.15875L22.2422 8.17706C22.2957 10.9963 22.3619 14.505 21.1864 17.6931Z"
        stroke="#232329"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 3"
        d="M8 13.6667L10.6667 16.3333L16 11"
        stroke="#232329"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const ExcellenceIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} width="26" height="26" viewBox="0 0 26 26" fill="none">
    <g id="g23">
      <g id="Group 35">
        <path
          id="path20"
          d="M13 1C6.38148 1 1 6.38148 1 13C1 19.6185 6.38148 25 13 25C19.6185 25 25 19.6185 25 13C25 6.38148 19.6185 1 13 1Z"
          stroke="#232329"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        id="path22"
        d="M12.9998 5.5C12.7099 5.5 12.5364 5.62455 12.4285 5.71387C12.3207 5.80319 12.2576 5.88624 12.1971 5.96875C12.0761 6.13377 11.98 6.3069 11.8807 6.50488C11.6821 6.90085 11.4794 7.388 11.2801 7.87891C11.0808 8.36981 10.8863 8.8618 10.7264 9.23242C10.6555 9.39665 10.597 9.52507 10.5477 9.62207C10.44 9.63915 10.2999 9.65797 10.1199 9.6748C9.71802 9.71239 9.18941 9.74536 8.66095 9.7832C8.13249 9.82104 7.60476 9.86319 7.16681 9.92969C6.94783 9.96294 6.75469 9.99745 6.56036 10.0615C6.46319 10.0936 6.36516 10.1301 6.24688 10.2051C6.1286 10.2801 5.9556 10.4069 5.86602 10.6826C5.77645 10.9583 5.84371 11.1618 5.89532 11.292C5.94693 11.4222 6.00547 11.5078 6.06524 11.5908C6.1848 11.7569 6.32072 11.901 6.47833 12.0566C6.79355 12.3679 7.19218 12.7115 7.59747 13.0527C8.00276 13.394 8.41063 13.7294 8.71368 13.9961C8.84902 14.1152 8.95306 14.215 9.03009 14.292C9.01299 14.3995 8.98736 14.5359 8.94806 14.7109C8.85961 15.1048 8.72674 15.6175 8.59942 16.1318C8.47211 16.6461 8.34925 17.1596 8.27716 17.5967C8.24111 17.8152 8.21475 18.0102 8.21563 18.2148C8.21608 18.3172 8.22189 18.422 8.25665 18.5576C8.29142 18.6933 8.35612 18.897 8.59063 19.0674C8.82515 19.2378 9.03973 19.2374 9.1795 19.2285C9.31927 19.2197 9.41897 19.1923 9.51641 19.1611C9.7113 19.0987 9.891 19.0139 10.0877 18.9121C10.4811 18.7085 10.9299 18.4333 11.3797 18.1533C11.8295 17.8733 12.2776 17.5886 12.6248 17.3828C12.7791 17.2914 12.9029 17.2243 12.9998 17.1748C13.0968 17.2243 13.2205 17.2914 13.3748 17.3828C13.7221 17.5886 14.1702 17.8733 14.6199 18.1533C15.0697 18.4333 15.5185 18.7085 15.9119 18.9121C16.1086 19.0139 16.2883 19.0987 16.4832 19.1611C16.5807 19.1923 16.6804 19.2197 16.8201 19.2285C16.9599 19.2374 17.1745 19.2378 17.409 19.0674C17.6435 18.897 17.7082 18.6933 17.743 18.5576C17.7777 18.422 17.7836 18.3172 17.784 18.2148C17.7849 18.0102 17.7585 17.8152 17.7225 17.5967C17.6504 17.1596 17.5275 16.6461 17.4002 16.1318C17.2729 15.6175 17.14 15.1048 17.0516 14.7109C17.0123 14.5359 16.9866 14.3995 16.9695 14.292C17.0466 14.215 17.1506 14.1152 17.2859 13.9961C17.589 13.7294 17.9969 13.394 18.4022 13.0527C18.8074 12.7115 19.2061 12.3679 19.5213 12.0566C19.6789 11.901 19.8148 11.7569 19.9344 11.5908C19.9942 11.5078 20.0527 11.4222 20.1043 11.292C20.1559 11.1618 20.2232 10.9583 20.1336 10.6826C20.044 10.4069 19.871 10.2801 19.7527 10.2051C19.6345 10.1301 19.5364 10.0936 19.4393 10.0615C19.2449 9.99745 19.0518 9.96294 18.8328 9.92969C18.3949 9.86319 17.8671 9.82104 17.3387 9.7832C16.8102 9.74536 16.2816 9.7124 15.8797 9.6748C15.6997 9.65797 15.5596 9.63915 15.452 9.62207C15.4027 9.52507 15.3441 9.39665 15.2733 9.23242C15.1133 8.8618 14.9188 8.36981 14.7195 7.87891C14.5203 7.388 14.3175 6.90085 14.119 6.50488C14.0197 6.3069 13.9235 6.13377 13.8025 5.96875C13.7421 5.88624 13.679 5.80319 13.5711 5.71387C13.4632 5.62455 13.2897 5.5 12.9998 5.5Z"
        stroke="#232329"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const PassionIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} width="26" height="25" viewBox="0 0 26 25" fill="none">
    <g id="ic/passion">
      <path
        id="Vector"
        d="M23.0961 4.06812C21.8537 2.72064 20.149 1.97852 18.2956 1.97852C16.9102 1.97852 15.6415 2.4165 14.5245 3.28021C13.9609 3.71619 13.4503 4.24957 13 4.87213C12.5499 4.24976 12.0391 3.71619 11.4753 3.28021C10.3585 2.4165 9.08978 1.97852 7.70441 1.97852C5.85101 1.97852 4.14612 2.72064 2.90375 4.06812C1.67621 5.39984 1 7.21918 1 9.19122C1 11.2209 1.75641 13.0789 3.38037 15.0385C4.83313 16.7914 6.92108 18.5708 9.33899 20.6313C10.1646 21.335 11.1005 22.1326 12.0722 22.9822C12.3289 23.207 12.6583 23.3308 13 23.3308C13.3415 23.3308 13.6711 23.207 13.9274 22.9825C14.8992 22.1328 15.8356 21.3348 16.6616 20.6307C19.0791 18.5706 21.1671 16.7914 22.6198 15.0383C24.2438 13.0789 25 11.2209 25 9.19104C25 7.21918 24.3238 5.39984 23.0961 4.06812Z"
        stroke="#232329"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const ValuesSection: React.FC<{
  valuesData?: OurValue[];
}> = ({ valuesData: customValuesData }) => {
  const { t } = useTranslation();

  const valuesData = customValuesData || [
    {
      title: t("aboutPage.valuesSection.transparency.title"),
      description: t("aboutPage.valuesSection.transparency.description"),
      icon: <TransparencyIcon className="m-2 self-end" />,
      bgColor: "bg-[#E2DDD7]",
    },
    {
      title: t("aboutPage.valuesSection.collaboration.title"),
      description: t("aboutPage.valuesSection.collaboration.description"),
      icon: <CollaborationIcon className="m-2 self-end" />,
      bgColor: "border border-[#E2DDD7]",
    },
    {
      title: t("aboutPage.valuesSection.sustainability.title"),
      description: t("aboutPage.valuesSection.sustainability.description"),
      icon: <SustainabilityIcon className="m-2 self-end" />,
      bgColor: "bg-[#E2DDD7]",
    },
    {
      title: t("aboutPage.valuesSection.integrity.title"),
      description: t("aboutPage.valuesSection.integrity.description"),
      icon: <IntegrityIcon className="m-2 self-end" />,
      bgColor: "border border-[#E2DDD7]",
    },
    {
      title: t("aboutPage.valuesSection.excellence.title"),
      description: t("aboutPage.valuesSection.excellence.description"),
      icon: <ExcellenceIcon className="m-2 self-end" />,
      bgColor: "bg-[#E2DDD7]",
    },
    {
      title: t("aboutPage.valuesSection.passion.title"),
      description: t("aboutPage.valuesSection.passion.description"),
      icon: <PassionIcon className="m-2 self-end" />,
      bgColor: "border border-[#E2DDD7]",
    },
  ];

  return (
    <>
      {valuesData.map((value, index) => (
        <div
          key={value.title}
          className={`flex flex-col justify-start ${index % 2 === 0 ? "bg-[#E2DDD7]" : "border border-[#E2DDD7]"} mt-6 flex h-[200px] flex-col justify-between rounded-[16px] p-4 md:mt-0 md:h-[290px] lg:h-[264px]`}
        >
          {value.icon && typeof value.icon === "object" && "large_url" in value.icon ? (
            <div className="flex w-full justify-end">
              <img src={value.icon.large_url} alt={value.title} className="h-6 w-6" />
            </div>
          ) : (
            value.icon
          )}
          <div className="overflow-hidden px-2">
            <h6 className="mt-4 text-xl font-bold">{value.title}</h6>
            <p className="mb-2 mt-6">{value.description}</p>
          </div>
        </div>
      ))}
    </>
  );
};
